'use client';
export default function AppDirI18nProvider(_a) {
    var lang = _a.lang, _b = _a.namespaces, namespaces = _b === void 0 ? {} : _b, config = _a.config, children = _a.children;
    globalThis.__NEXT_TRANSLATE__ = { lang: lang, namespaces: namespaces, config: config };
    return children;
}
